/* Filosogno One — single-product helpers */
(() => {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  /* sticky buy bar */
  const box = $('[data-o-buy]'), bar = $('[data-o-bar]');
  if (box && bar) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('button,a', bar).forEach(b => b.tabIndex = on ? 0 : -1);
    }).observe(box);
  }
  /* preview state: buttons explain why they don't buy yet */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-o-preview]'); if (!b) return;
    e.preventDefault();
    const n = $('[data-o-preview-note]'); if (!n) return;
    n.classList.remove('is-pulse'); void n.offsetWidth; n.classList.add('is-pulse');
    if (b.closest('[data-o-bar]')) n.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  /* gallery dots on mobile */
  $$('[data-o-gal]').forEach(g => {
    const t = $('[data-o-gal-track]', g), dots = $$('.o-pd__dots i', g), sl = $$('.o-pd__slide', g);
    if (!t || !dots.length) return;
    t.addEventListener('scroll', () => requestAnimationFrame(() => {
      const i = Math.round(t.scrollLeft / Math.max(sl[0].offsetWidth, 1));
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
    }), { passive: true });
  });
  /* only one FAQ open at a time */
  $$('.o-faq__list').forEach(l => l.addEventListener('toggle', e => {
    if (e.target.open) $$('details', l).forEach(d => d !== e.target && (d.open = false));
  }, true));
})();
/* close the menu when a link inside it is tapped */
document.addEventListener('click', e => {
  const a = e.target.closest('#MenuDrawer a[href]');
  if (!a) return;
  const c = document.querySelector('#MenuDrawer [data-close]');
  if (c) c.click();
});
